export const BIG_TEXT_SIZE = 800
export const TITLE_TEXT_SIZE = 100
